if (!customElements.get('sidenav-menu')) {
  class SidenavMenu extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.target = document.querySelector(this.dataset.target);
      this.nav = this.querySelector('ul');

      if (!this.target || !this.nav) return;

      this.headers = this.target.querySelectorAll('h2');

      this.renderMenu();
      x;
    }

    renderMenu() {
      let pageTitle = document.title.split('–')[0].trim();
      const titleItem = document.createElement('li');
      titleItem.className = 'sidenav-menu__title';
      titleItem.textContent = pageTitle;

      this.nav.insertBefore(titleItem, this.nav.firstChild);

      this.headers.forEach((h) => {
        h.id = h.textContent
          .trim()
          .toLowerCase()
          .replaceAll(' ', '-')
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '');

        const item = document.createElement('li');
        const link = document.createElement('a');
        link.className = 'sidenav-menu__link link';
        link.href = `#${h.id}`;
        link.textContent = h.textContent;

        item.appendChild(link);
        this.nav.appendChild(item);
      });
    }
  }

  customElements.define('sidenav-menu', SidenavMenu);
}
